import * as messaging from "firebase/messaging";
import { SnackbarMessage, OptionsObject, SnackbarKey } from "notistack";
import React from "react";
import NotificationSnackbar, {
  INotificationSnackbar,
} from "../components/NotificationSnackbar";
import { initializeApp } from "firebase/app";
export const displayDesktopNotification = (
  message: messaging.MessagePayload
) => {
  navigator.serviceWorker
    .getRegistration("/firebase-cloud-messaging-push-scope")
    .then((req) => {
      const notificationTitle = message.notification?.title;
      const notificationOptions = {
        body: message.notification?.body,
        icon: message.notification?.image,
      };
      req?.showNotification(notificationTitle!, notificationOptions);
    });
};

export const displaySnackbarNotification = (
  message: messaging.MessagePayload,
  enqueueSnackbar: (
    message: SnackbarMessage,
    options?: OptionsObject | undefined
  ) => SnackbarKey
) => {
  enqueueSnackbar(message?.notification, {
    variant: "success",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    content: (key, message: INotificationSnackbar) => (
      <NotificationSnackbar id={key} message={message} />
    ),
  });
};

const firebaseConfig = {
  //from firebase project setting
  apiKey: "AIzaSyBapZ5lUai_V56Hditxq2LnxnvZAXAyIQw",
  authDomain: "curess-47dfb.firebaseapp.com",
  projectId: "curess-47dfb",
  storageBucket: "curess-47dfb.appspot.com",
  messagingSenderId: "216695885753",
  appId: "1:216695885753:web:b35a62e3b9730b3ad2f068",
  measurementId: "G-9SEQTWM2GW",
};
export const vapidKey =
  "BO6AFWziJGFuh-yPGoKf8uDMojljuqJ_7XrPNrY9X_RiNAE26Qk5LVhs5-D-4VwZL9PgFARF3OnBEk58T-Rx1dg";

export const app = initializeApp(firebaseConfig);
export const instance = messaging.getMessaging(app);
